import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { goBackInApp } from 'lib/navigation';
import { useBackFallback } from 'hooks/useBackFallback';

interface PageBackButtonProps {
  className?: string;
  label?: string;
  fallback?: Parameters<typeof goBackInApp>[1];
}

export default function PageBackButton({ className = '', label = 'Back', fallback }: PageBackButtonProps) {
  const navigate = useNavigate();
  const defaultFallback = useBackFallback();
  const target = fallback ?? defaultFallback;

  return (
    <button
      type="button"
      onClick={() => goBackInApp(navigate, target)}
      className={`page-back-btn page-hero-back-btn inline-flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-xs font-semibold uppercase tracking-wide transition ${className}`}
      aria-label={label}
    >
      <ArrowLeft size={14} strokeWidth={2.25} />
      <span>{label}</span>
    </button>
  );
}
